/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  /********
 * Debounce function
 *
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The function will be called after it stops being called for N milliseconds.
 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 *
 * Reference: https://davidwalsh.name/javascript-debounce-function
 ********/

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/******
 * Mobile and Desktop  Menu Switch
 *
 * Desktop Menu: Second level menu dropdown
 * Mobile Menu: Second level menu slide to open
 ******/
var menuState = "";
var navigationBreakpoint = 1240;
var mobileDesktopMenuSwitch = debounce(function() {
  if(menuState !== "mobile" && window.innerWidth < navigationBreakpoint) {
    menuState = "mobile";
    jQuery('.hamburger-icon').on('click', function(e){
      e.preventDefault();
      jQuery(this).toggleClass('active');
      jQuery(this).parents('.mobile-menu').toggleClass('first-level-open');
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
      jQuery('html').toggleClass('no-scroll');
    });

    jQuery('.menu-item-has-children > a').click(function(e){
      e.preventDefault();
      jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
      jQuery(this).parent().toggleClass('open');
    });

    jQuery('.menu-item-has-children > a').one('click', function(e){
      //This code onle need to run once
      jQuery(this).siblings('.second-level-menu').find('.second-level-parent').append(jQuery(this).clone());
    });

    jQuery('.mobile-menu .back-to-main').click(function(e) {
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
    });
  } else if(window.innerWidth >= navigationBreakpoint) {
    menuState = "desktop";
    jQuery('.hamburger-icon').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.second-level-menu .back').off('click');
  }
}, 250);

mobileDesktopMenuSwitch(); //run one on load
window.addEventListener('resize', mobileDesktopMenuSwitch);

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });

	jQuery(".arrow_down").on('click', function() {
		jQuery('html, body').animate({
					scrollTop: jQuery("#page_body").offset().top
			}, 2000);
	});

	jQuery('.gallery__slider').slick({
		slidesToShow: 2,
		infinite: true,
		dots: false,
		centerMode: true,
		focusOnSelect: true,
		arrows: true,
		swipeToSlide: false,
		prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-purple-left.png' class='slick-prev' />",
		nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-purple-right.png' class='slick-next' />",
		responsive: [
			{
				breakpoint: 680,
				settings: {
						slidesToShow: 1,
				}
			}
		]
	});

	/*****
 * Initialize Lightbox Gallery
 *****/
function initLightbox(parentClass) {
  if(typeof parentClass === 'undefined' || !parentClass) return; //early return if parentClass is undefined

  jQuery(parentClass+'__image_bg, '+parentClass+'__more').on('click', function(){
    var index = jQuery(this).data('index');
    var lightbox = jQuery(this).parents(parentClass).find(parentClass+'__lightbox');
    
    lightbox.addClass('active');
    setTimeout(function() { //strangely needs timeout to works
      lightbox.find('.lightbox').slick('slickGoTo', index, true);
    }, 10);

    jQuery('html').css('overflow-y', 'hidden');
    jQuery('body').css('overflow-y', 'hidden');
  });

  jQuery(parentClass+'__lightbox--close').on('click', function(){
    jQuery(this).parent().removeClass('active');

    jQuery('html').css('overflow-y', 'auto');
    jQuery('body').css('overflow-y', 'auto');
  });

  //Main Slider
  jQuery(parentClass+'__lightbox .lightbox').slick({
    slidesToShow: 1,
    infinite: false,
    dots: false,
    lazyLoad: 'ondemand',
    arrows: true,
    prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
    nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
    asNavFor: parentClass+'__lightbox .lightbox-navigation',
  });

  //Navigation Slider
  jQuery(parentClass+'__lightbox .lightbox-navigation').slick({
    slidesToShow: 3,
    infinite: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: true,
    swipeToSlide: true,
    prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
    nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
    asNavFor: parentClass+'__lightbox .lightbox',
    responsive: [
      {
        breakpoint: 680,
        settings: {
            slidesToShow: 3,
        }
      }
    ]
  });

  //Navigation Slider
  jQuery('.post_slider_wrap').slick({
    slidesToShow: 3,
    dots: false,
    arrows: true,
    swipeToSlide: true,
    prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/post-arrow-left.png' class='slick-prev' />",
    nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/post-arrow-right.png' class='slick-next' />",
    responsive: [
      {
        breakpoint: 981,
        settings: {
            slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
        }
      }
    ]
  });
}
initLightbox('.gallery');
    
  // var tatcEventsSlider = new Swiper('.__tatc_events_slider', {
	// 	slidesPerView: 1,
	//     spaceBetween: 8,
	//     loop: true,
	//     loopedSlides: 4,
	//     speed: 500,
	//     slideToClickedSlide: false,
	// 		centeredSlides: true,
	//     navigation: {
	//         nextEl: '.swiper-btn-next',
	//         prevEl: '.swiper-btn-prev',
  // 		},
	// 	breakpoints: {
	// 			// when window width is >= 512px
	// 			512: {
	// 			slidesPerView: 1,
	// 			spaceBetween: 8
	// 		},
	// 			// when window width is >= 768px
	// 			768: {
	// 			slidesPerView: 3,
	// 			spaceBetween: 8
	// 		},
	// 			// when window width is >= 1024px
	// 			1024: {
	// 			slidesPerView: 3,
	// 			spaceBetween: 8
	// 		},
	// 			// when window width is >= 1200px
	// 			1200: {
	// 			slidesPerView: 4,
	// 			spaceBetween: 8
	// 		},
	// 	}
	// });


  jQuery('.text-section table').attr('border', '0');
  jQuery('.text-section table').attr('cellspacing', '0');
  jQuery('.text-section table').attr('cellpadding ', '0');
});